import React from "react";
import { useParams } from "react-router-dom";

import { PlaylistInterface, ApiHelper, PendingCommand, PlaylistMessageInterface, SubscriptionInterface, ToastHelper } from "../helpers"
import { Row, Col } from "react-bootstrap"
import { AvailableContent, PlaylistEdit, Subset, Conditions } from "./components"

interface Props {
  refreshSidebar: () => void,
}


export const PlaylistPage = (props: Props) => {
  const { id } = useParams<{ id: string }>();

  const [playlist, setPlaylist] = React.useState<PlaylistInterface>(null);
  const [editCommand, setEditCommand] = React.useState<PendingCommand>(null);
  const [editSubset, setEditSubset] = React.useState<PlaylistMessageInterface>(null);
  const [editConditions, setEditConditions] = React.useState<PlaylistMessageInterface>(null);
  const [subscription, setSubscription] = React.useState<SubscriptionInterface>(null);

  const params: any = new URLSearchParams(window.location.search);
  const externalFeed = params.get("mode") === "externalFeed" || playlist?.mode === "external";
  const slideshow = params.get("mode") === "slideshow" || playlist?.mode === "slideshow";

  const init = async () => {
    if (id === "0") {
      let playlistName = "";
      const params: any = new URLSearchParams(window.location.search);
      const subscriptionId = parseInt(params.get("subscriptionId"), 0);
      let shape = params.get("shape");
      if (!shape) shape = "16:9"
      let mode = "normal";
      if (externalFeed) mode = "external"
      else if (slideshow) mode = "slideshow";
      else if (subscriptionId) {
        const sub = await ApiHelper.get<SubscriptionInterface>("/subscriptions/" + subscriptionId)
        setSubscription(sub);
        const feed = await ApiHelper.get<{ id?: number; name?: string }>("/feeds/" + sub?.feedId)
        playlistName = feed?.name + " Playlist";
        mode = "subscription";
      }

      console.log("setting playlist")
      setPlaylist({ id: 0, name: playlistName, subscriptionId: subscriptionId, shape: shape, externalSourceUrl: null, mode: mode });
    }
    else {
      ApiHelper.get<PlaylistInterface>("/playlists/" + id)
        .then((data) => { setPlaylist(data); })
        .catch(err => {
          console.error("Failed to load playlist:", err);
          ToastHelper.error("Failed to load playlist");
        });
    }
  }

  const handleCommandReceived = (cmd: PendingCommand) => {
    switch (cmd.action) {
      case "addMessage":
      case "addPlaylist":
        setEditCommand(cmd);
        break;
      case "cancelSubset":
        setEditSubset(null);
        break;
      case "updateSubset":
        setEditCommand(cmd);
        setEditSubset(null);
        break;
      case "updateConditions":
        setEditCommand(cmd);
        setEditConditions(null);
        break;
    }
  }


  const handlePlaylistEditCommand = (cmd: PendingCommand) => {
    if (cmd.action === "subset") setEditSubset(JSON.parse(cmd.parameter as string));
    if (cmd.action === "conditions") setEditConditions(JSON.parse(cmd.parameter as string));
  }

  const getRightSide = () => {
    if (editSubset) return <Subset playlistMessage={editSubset} sendCommand={handleCommandReceived} />;
    else if (editConditions) return <Conditions playlistMessage={editConditions} sendCommand={handleCommandReceived} />;
    else if (playlist && !playlist.subscriptionId && !externalFeed && !slideshow) return (<AvailableContent playlist={playlist} sendCommand={handleCommandReceived} />);
  }

  React.useEffect(() => { init() }, [id]) //eslint-disable-line

  return (
    <>
      <h1><i className="fas fa-list-ul"></i> {(playlist?.id === 0) ? "New Custom Playlist" : "Edit Playlist"}</h1>
      <Row>
        <Col md={6}>
          <PlaylistEdit playlist={playlist} subscriptionData={JSON.parse(subscription?.data || "{}")} refreshSidebar={props.refreshSidebar} pendingCommand={editCommand} sendCommand={handlePlaylistEditCommand} />
        </Col>
        <Col md={6}>
          {getRightSide()}
        </Col>
      </Row>
    </>
  )


};